import { useMemo } from "react";
import { useSelector } from "react-redux";

import { selectCurrentAccount, selectGuestAccounts } from "fond/api";

/**
 * Hook to determine if the user is currently switched to a guest account.
 * Guest accounts are accounts where the user has access to shared items but is not a member.
 *
 * @returns true if the current account is a guest account, false otherwise
 */
export const useIsGuestAccount = (): boolean => {
  const currentAccount = useSelector(selectCurrentAccount);
  const guestAccounts = useSelector(selectGuestAccounts);

  return useMemo(() => {
    if (!currentAccount?.ID) {
      return false;
    }

    return guestAccounts.some((guestAccount) => guestAccount.ID === currentAccount.ID);
  }, [currentAccount?.ID, guestAccounts]);
};
